<template>
    <div class="wrapper">
      <h3>{{ msg }}</h3>
      <div class="table-responsive">
        <table class="table-hover commentList" v-if="comments.length > 0">
            <thead>
              <tr>
                <th>Användare</th>
                <th>Kommentar</th>
                <th>Skapad</th>
                <th>Bild</th>
                <th>Kvittens</th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="comment in comments" :key="comment.id">
                <td>{{ comment.User.firstName + ' ' + comment.User.lastName }}</td>
                <td v-if="editId != comment.id">{{ comment.text }}</td>
                <td v-if="edit == true && editId == comment.id"> <InputText type="text" name="commentText" v-model="comment.text" /></td>
                <td>{{ comment.createdAt}}</td>
                <td>
                  <a v-if="comment.imageId != null" target="_blank" :href="'/api/images/' + comment.imageId"><img :src="'/api/images/preview/' + comment.imageId" /></a>
                  <div v-if="edit == true && editId == comment.id && comment.imageId != null">
                    <a href="#" v-on:click="onDeleteImage(comment, $event)">Radera bild</a>
                </div>
                  <!--<vue-pure-lightbox v-if="comment.imageId"
                    style="width: 20em"
                    :thumbnail="'/api/images/' + comment.imageId"
                    :images="['/api/images/preview/' + comment.imageId]"
                  ></vue-pure-lightbox>-->
                </td>
                <td v-if="editId != comment.id">
                  <span v-if="comment.receipt == true">Ja</span>
                  <span v-else>Nej</span>
                </td>
                <td v-else>
                  <input type="checkbox" v-model="comment.receipt"/>
                </td>
                <td><button v-on:click="onDelete(objectId, comment.id, $event)">Ta bort</button></td>
                <td><button v-if="editId != comment.id" v-on:click="onEdit(comment.id)">Ändra</button><button v-if="edit == true && editId == comment.id" v-on:click="onSave(comment)">Spara</button></td>
                <td v-if="edit == true && editId == comment.id"><button v-on:click="onCancel()">Avbryt</button></td>
                <td v-if="editId != comment.id"></td>
                <td v-else></td>
                <td v-if="comment.receipt == true"><button v-on:click="getReceipts(comment.id)">{{ toggleShowReceipts }}</button></td>
              </tr>
              <tr v-if="receipts.length > 0">
              <td colspan="9">
                  <table width="100%">
                    <tr>
                      <td><strong>Användare</strong></td>
                      <td><strong>Skapad</strong></td>
                    </tr>
                    <tr v-for="receipt in receipts" :key="receipt.id">
                      <td>{{ receipt.user }}</td>
                      <td>{{ formatReceiptDateAndTime(receipt.createdAt) }}</td>
                    </tr>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
    </div>
</template>

<script>
import { bus } from '../../main'
import InputText from 'primevue/inputtext'
// import VuePureLightbox from 'vue-pure-lightbox'
// import styles from 'vue-pure-lightbox/dist/VuePureLightbox.css'
export default {
  name: 'CommentList',
  components: {
    InputText
  },
  data () {
    return {
      comments: [],
      msg: 'Kommentarer',
      edit: false,
      editId: null,
      receipts: [],
      toggleShowReceipts: 'Visa kvittenser'
    }
  },
  props: {
    objectId: {
      type: String,
      default: ''
    }
  },
  created () {
    bus.$on('addedComment', obj => {
      this.comments.push(obj)
    })
    bus.$on('deletedComment', obj => {
      let index = this.comments.indexOf(obj)
      this.comments.splice(index, 1)
    })
  },
  mounted () {
    if (this.$props.objectId.length === 0) {
      return
    }
    this.fetchComments(this.$props.objectId)
  },
  watch: {
    objectId: function (newVal, oldVal) {
      this.fetchComments(newVal)
    }
  },
  methods: {
    fetchComments (objectId) {
      var url = '/api/comments/' + objectId
      this.$http
        .get(url)
        .then(response => {
          this.comments = response.data
        })
        .catch(error => console.log(error))
    },
    onEdit (commentId) {
      this.edit = true
      this.editId = commentId
    },
    getReceipts (id) {
      if (this.toggleShowReceipts === 'Visa kvittenser') {
        var url = '/api/commentreceipts/bycomment/' + id
        this.$http
          .get(url)
          .then(response => {
            this.receipts = response.data
            this.toggleShowReceipts = 'Dölj kvittenser'
          })
          .catch(error => console.log(error))
      } else {
        this.toggleShowReceipts = 'Visa kvittenser'
        this.receipts = []
      }
    },
    formatReceiptDateAndTime (date) {
      const options = { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }
      return new Date(date).toLocaleDateString(undefined, options)
    },
    onSave (comment) {
      var url = '/api/comments/' + comment.id
      this.$http
        .put(url, {
          comment: comment
        })
        .then(response => {
          this.edit = false
          this.editId = null
        })
        .catch(error => console.log(error))
    },
    onCancel () {
      this.edit = false
      this.editId = null
    },
    onDeleteImage (comment, evt) {
      evt.preventDefault()
      comment.imageId = null
    },
    onDelete (objectId, commentId, evt) {
      evt.preventDefault()
      let message = 'Är du säker?'
      let options = {
        okText: 'Fortsätt',
        cancelText: 'Stäng'
      }
      this.$dialog.confirm(message, options)
        .then(dialog => {
          var url = '/api/comments/' + commentId
          this.$http
            .delete(url)
            .then(response => {
              bus.$emit('deletedComment', response.data)
            })
            .catch(error => console.log(error))
        })
        .catch(function () {
          console.log('Clicked on cancel')
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Comments/CommentList.vue